// page-nav — wireframe skin module
// Token disposition: color tokens overridden to wf-* namespace; spacing/sizing pass-through
// NO external imports — plain JavaScript only

const CHEVRON_LEFT = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M10 12L6 8l4-4" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const CHEVRON_RIGHT = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M6 4l4 4-4 4" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

export const styles = `
  :host {
    display: block;
  }

  nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--run-page-nav-padding, 1rem 0);
    gap: 1rem;
  }

  .pn-link {
    display: inline-flex;
    align-items: center;
    gap: var(--run-page-nav-gap, 0.5rem);
    color: var(--run-wf-color-interactive, #555);
    text-decoration: none;
    font-size: var(--run-page-nav-label-size, 0.875rem);
    font-weight: 500;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    border: 1px dashed #aaa;
  }

  .pn-next {
    margin-left: auto;
  }

  .pn-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  svg {
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    nav {
      flex-direction: column;
      align-items: stretch;
    }
    .pn-link {
      max-width: 100%;
    }
    .pn-next {
      margin-left: 0;
      justify-content: flex-end;
    }
  }
`;

function escape(str) {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function safeHref(href) {
  const trimmed = href.trim().toLowerCase();
  if (trimmed.startsWith('javascript:') || trimmed.startsWith('data:')) return '#';
  return escape(href);
}

export function render(host) {
  const { prevLabel, prevHref, nextLabel, nextHref } = host;
  const showPrev = prevLabel !== '' && prevHref !== '';
  const showNext = nextLabel !== '' && nextHref !== '';

  const prevHtml = showPrev
    ? `<a class="pn-link pn-prev" href="${safeHref(prevHref)}" aria-label="Previous: ${escape(prevLabel)}" part="link link-prev">
        ${CHEVRON_LEFT}
        <span class="pn-label">${escape(prevLabel)}</span>
      </a>`
    : '';

  const nextHtml = showNext
    ? `<a class="pn-link pn-next" href="${safeHref(nextHref)}" aria-label="Next: ${escape(nextLabel)}" part="link link-next">
        <span class="pn-label">${escape(nextLabel)}</span>
        ${CHEVRON_RIGHT}
      </a>`
    : '';

  host.shadowRoot.innerHTML = `
    <nav aria-label="Component navigation" part="nav">
      ${prevHtml}
      ${nextHtml}
    </nav>
  `;
}
